import React from 'react';
import { toDecimalPoint } from '../../../utils/decimalUtils';
import DecimalInput from '../../fields/DecimalInput';

const DataSection = ({
  displayData,
  savedModalData,
  calculateDamage_0_func,
  calculateDamagePercentage_func,
  isDamageSumValid_func,
  updateDataItem,
  openModal,
  openCauseModal,
  tableScrollRef,
  tableScrollPosition,
  handleTableSliderChange,
  handleTableScroll,
  handbooks
}) => {
  return (
    <div className="group-section">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
        <h4>Данные</h4>
      </div>
      
      <div 
        ref={tableScrollRef}
        onScroll={handleTableScroll}
        style={{ 
          overflowX: 'auto', 
          overflowY: 'visible',
          maxWidth: '100%',
          border: '1px solid #ddd',
          borderRadius: '6px'
        }}>
        <table className="table" style={{ 
          minWidth: '1350px',
          width: 'max-content',
          marginBottom: 0
        }}>
          <thead>
            <tr>
              <th style={{ minWidth: '62px', width: '62px', height: '60px', verticalAlign: 'middle' }}>Ярус</th>
              <th style={{ minWidth: '74px', width: '74px', height: '60px', verticalAlign: 'middle' }}>Доля</th>
              <th style={{ minWidth: '104px', width: '104px', height: '60px', verticalAlign: 'middle' }}>Порода</th>
              <th style={{ minWidth: '100px', width: '100px', height: '60px', verticalAlign: 'middle' }}>Ср. возраст, лет</th>
              <th style={{ minWidth: '100px', width: '100px', height: '60px', verticalAlign: 'middle' }}>Ср. высота, м</th>
              <th style={{ minWidth: '100px', width: '100px', height: '60px', verticalAlign: 'middle' }}>Ср. диаметр, см</th>
              <th style={{ minWidth: '66px', width: '66px', height: '60px', verticalAlign: 'middle' }}>0%</th>
              <th style={{ minWidth: '84px', width: '84px', height: '60px', verticalAlign: 'middle' }}>1-25%</th>
              <th style={{ minWidth: '84px', width: '84px', height: '60px', verticalAlign: 'middle' }}>26-50%</th>
              <th style={{ minWidth: '84px', width: '84px', height: '60px', verticalAlign: 'middle' }}>51-75%</th>
              <th style={{ minWidth: '84px', width: '84px', height: '60px', verticalAlign: 'middle' }}>76-100%</th>
              <th style={{ minWidth: '150px', width: '150px', height: '60px', verticalAlign: 'middle' }}>Повреждение крон</th>
              <th style={{ minWidth: '150px', width: '150px', height: '60px', verticalAlign: 'middle' }}>Причина</th>
            </tr>
          </thead>
          <tbody>
            {(() => {
              const dataArray = Array.isArray(displayData?.data) ? displayData.data : (displayData?.data ? [displayData.data] : []);
              return dataArray.map((item, index) => {
                return (
              <tr key={item.id}>
                {/* Ярус */}
                <td className="coordinate-cell" style={{ minWidth: '62px', width: '62px', height: '60px', verticalAlign: 'middle' }}>
                  <input
                    type="text"
                    value={item.yarus}
                    readOnly
                    className="form-control coordinate-field"
                    style={{ background: '#f8f9fa', cursor: 'not-allowed', height: '40px' }}
                  />
                </td>

                {/* Доля */}
                <td className="coordinate-cell" style={{ minWidth: '74px', width: '74px', height: '60px', verticalAlign: 'middle' }}>
                  <input
                    type="text"
                    value={item.dolap}
                    readOnly
                    className="form-control coordinate-field"
                    style={{ background: '#f8f9fa', cursor: 'not-allowed', height: '40px' }}
                  />
                </td>

                {/* Порода */}
                <td className="coordinate-cell" style={{ minWidth: '104px', width: '104px', height: '60px', verticalAlign: 'middle' }}>
                  <input
                    type="text"
                    value={(() => {
                      const handbook = handbooks?.find(h => h.id === 31);
                      if (handbook && handbook.references && item.kodporoda) {
                        const selectedOption = handbook.references.find(r => r.id.toString() === String(item.kodporoda));
                        return selectedOption ? selectedOption.name : item.kodporoda;
                      }
                      return item.kodporoda || '';
                    })()}
                    readOnly
                    className="form-control coordinate-field"
                    style={{ background: '#f8f9fa', cursor: 'not-allowed', height: '40px' }}
                  />
                </td>

                {/* Ср. возраст */}
                <td className="coordinate-cell" style={{ minWidth: '100px', width: '100px', height: '60px', verticalAlign: 'middle' }}>
                  <input
                    type="text"
                    value={item.vozr}
                    readOnly
                    className="form-control coordinate-field"
                    style={{ background: '#f8f9fa', cursor: 'not-allowed', height: '40px' }}
                  />
                </td>

                {/* Ср. высота */}
                <td className="coordinate-cell" style={{ minWidth: '100px', width: '100px', height: '60px', verticalAlign: 'middle' }}>
                  <input
                    type="text"
                    value={item.hsr}
                    readOnly
                    className="form-control coordinate-field"
                    style={{ background: '#f8f9fa', cursor: 'not-allowed', height: '40px' }}
                  />
                </td>

                {/* Ср. диаметр */}
                <td className="coordinate-cell" style={{ minWidth: '100px', width: '100px', height: '60px', verticalAlign: 'middle' }}>
                  <input
                    type="text"
                    value={item.dsr}
                    readOnly
                    className="form-control coordinate-field"
                    style={{ background: '#f8f9fa', cursor: 'not-allowed', height: '40px' }}
                  />
                </td>

                {/* 0% */}
                <td className="coordinate-cell" style={{ minWidth: '66px', width: '66px', height: '60px', verticalAlign: 'middle' }}>
                  <input
                    type="number"
                    min="0"
                    max="100"
                    value={calculateDamage_0_func(item)}
                    readOnly
                    className="form-control coordinate-field"
                    style={{ background: '#f8f9fa', cursor: 'not-allowed', height: '40px' }}
                  />
                </td>

                {/* 1-25% */}
                <td className="coordinate-cell" style={{ minWidth: '84px', width: '84px', height: '60px', verticalAlign: 'middle' }}>
                  <DecimalInput
                    value={item.objedola25 || ''}
                    onChange={(e) => {
                      const value = toDecimalPoint(e.target.value);
                      if (value === '' || (Number(value) >= 0 && Number(value) <= 100)) {
                        updateDataItem(item.id, 'objedola25', value);
                      }
                    }}
                    className={`form-control coordinate-field ${!isDamageSumValid_func(item) ? 'lp-error' : ''}`}
                    style={{ height: '40px' }}
                    placeholder="0-100"
                  />
                </td>

                {/* 26-50% */}
                <td className="coordinate-cell" style={{ minWidth: '84px', width: '84px', height: '60px', verticalAlign: 'middle' }}>
                  <DecimalInput
                    value={item.objedola50 || ''}
                    onChange={(e) => {
                      const value = toDecimalPoint(e.target.value);
                      if (value === '' || (Number(value) >= 0 && Number(value) <= 100)) {
                        updateDataItem(item.id, 'objedola50', value);
                      }
                    }}
                    className={`form-control coordinate-field ${!isDamageSumValid_func(item) ? 'lp-error' : ''}`}
                    style={{ height: '40px' }}
                    placeholder="0-100"
                  />
                </td>

                {/* 51-75% */}
                <td className="coordinate-cell" style={{ minWidth: '84px', width: '84px', height: '60px', verticalAlign: 'middle' }}>
                  <DecimalInput
                    value={item.objedola75 || ''}
                    onChange={(e) => {
                      const value = toDecimalPoint(e.target.value);
                      if (value === '' || (Number(value) >= 0 && Number(value) <= 100)) {
                        updateDataItem(item.id, 'objedola75', value);
                      }
                    }}
                    className={`form-control coordinate-field ${!isDamageSumValid_func(item) ? 'lp-error' : ''}`}
                    style={{ height: '40px' }}
                    placeholder="0-100"
                  />
                </td>

                {/* 76-100% */}
                <td className="coordinate-cell" style={{ minWidth: '84px', width: '84px', height: '60px', verticalAlign: 'middle' }}>
                  <DecimalInput
                    value={item.objedola100 || ''}
                    onChange={(e) => {
                      const value = toDecimalPoint(e.target.value);
                      if (value === '' || (Number(value) >= 0 && Number(value) <= 100)) {
                        updateDataItem(item.id, 'objedola100', value);
                      }
                    }}
                    className={`form-control coordinate-field ${!isDamageSumValid_func(item) ? 'lp-error' : ''}`}
                    style={{ height: '40px' }}
                    placeholder="0-100"
                  />
                </td>

                {/* Повреждение крон */}
                <td className="coordinate-cell" style={{ minWidth: '150px', width: '150px', height: '60px', verticalAlign: 'middle' }}>
                  <DecimalInput
                    value={calculateDamagePercentage_func(item)}
                    readOnly
                    className="form-control coordinate-field"
                    style={{ background: '#f8f9fa', cursor: 'not-allowed', height: '40px' }}
                  />
                </td>

                {/* Причина */}
                <td className="coordinate-cell" style={{ minWidth: '150px', width: '150px', height: '60px', verticalAlign: 'middle' }}>
                  <div 
                    className="reference-cell"
                    onClick={() => openCauseModal(item.id)}
                    style={{ 
                      minHeight: 60, 
                      height: 'auto',
                      cursor: 'pointer',
                      background: '#f8f9fa',
                      border: '1px solid #ced4da',
                      borderRadius: '4px',
                      padding: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      textAlign: 'center',
                      fontSize: '12px',
                      color: '#000000'
                    }}
                  >
                    {(() => {
                      const causes = item.causes || [];
                      if (causes.length === 0) {
                        return 'Выберите причину';
                      }
                      return `Выбрано: ${causes.length}`;
                    })()}
                  </div>
                </td>
              </tr>
                );
              });
            })()}
          </tbody>
        </table>
      </div>

      {/* Скроллбар для основной таблицы */}
      <div style={{ 
        marginTop: '10px',
        padding: '8px 12px',
        backgroundColor: '#f8f9fa',
        border: '1px solid #dee2e6',
        borderRadius: '6px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
      }}>
        <span style={{ 
          fontSize: '12px', 
          color: '#6c757d',
          minWidth: '60px'
        }}>
          Прокрутка:
        </span>
        <input
          type="range"
          min="0"
          max="100"
          value={tableScrollPosition}
          onChange={handleTableSliderChange}
          className="table-scroll-slider"
          style={{
            flex: 1
          }}
        />
        <span style={{ 
          fontSize: '12px', 
          color: '#6c757d',
          minWidth: '30px',
          textAlign: 'right'
        }}>
          {Math.round(tableScrollPosition)}%
        </span>
      </div>
    </div>
  );
};

export default DataSection;

